export const transformerColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型',
      type: 'input',
      placeholder: '变压器总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'spaceId',
      name: '片区',
      type: 'select',
      placeholder: '请选择片区',
      span: 12,
      value: 'id',
      label: 'name',
      options: ctx.spaceNameList,
    },
    {
      prop: 'meterNo',
      name: '电表编号',
      type: 'input',
      placeholder: '请输入',
      maxlength: 500,
      span: 12,
    },
    {
      prop: 'transformer',
      name: '变压器',
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率',
      type: 'inputAmount',
      placeholder: '请输入',
      precision: 2,
      max: 999999999,
      span: 12,
    },
    {
      prop: 'loss',
      name: '损耗',
      type: 'inputAmount',
      placeholder: '请输入',
      precision: 2,
      max: 999999999,
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      maxlength: 50,
      type: 'textarea',
      span: 24,
      placeholder: '请输入',
    },
  ];
};
export const lineColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型',
      type: 'input',
      placeholder: '变压器总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表编号',
      type: 'input',
      placeholder: '请输入',
      maxlength: 500,
      span: 12,
    },
    {
      prop: 'line',
      name: '线路',
      type: 'input',
      maxlength: 500,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'loss',
      name: '损耗',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 50,
      placeholder: '请输入',
    },
  ];
};
export const areaColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型',
      type: 'input',
      placeholder: '变压器总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表编号',
      type: 'input',
      placeholder: '请输入',
      span: 12,
      maxlength: 500,
    },
    {
      prop: 'areaName',
      name: '区域名称',
      type: 'input',
      maxlength: 20,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'loss',
      name: '损耗',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 50,
      placeholder: '请输入',
    },
  ];
};
export const regionColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '电表类型',
      type: 'input',
      placeholder: '变压器总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '电表编号',
      type: 'input',
      placeholder: '请输入',
      maxlength: 500,
      span: 12,
    },
    {
      prop: 'areaName',
      name: '区域名称',
      type: 'input',
      maxlength: 20,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'inductanceRatio',
      name: '电感比/倍率',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'loss',
      name: '损耗',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能电表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'selfUseFlag',
      name: '是否自用',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'virtualTableFlag',
      name: '是否虚拟表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      maxlength: 50,
      span: 24,
      placeholder: '请输入',
    },
  ];
};
